import moment from 'moment'
import toast from 'react-hot-toast'
import create, { GetState, SetState } from 'zustand'
import { screens } from '../pages/buy/gadgets/types'
import { Axios } from '../utils/axios'
import { handleAxiosError } from '../utils/error'
import useBVNStore from './BVN.store'

type GadgetState = {
  loading: boolean
  setLoading: (loading: boolean) => void
  fetchDefault: (price: string) => void
  gadgetDetails?: any
  setGadgetDetails: (loading: any) => void
  onboardBuyPolicy: () => void
  buyPolicy: () => void
  screen?: string
  setScreen: (loading: any) => void
  policy?: any
  policies?: any
  user_id?: number
  confirmPayment: any
  policy_id?: number
  paymentDetails?: any
  policy_number?: any
  plate?: string
  generateAccount: any
  errorMessage: string
  setErrorMsg: any
}

const defaultState = {
  loading: false,
  errorMessage: '',
  screen: 'ENTER_PLATE'
}

const GadgetStore = (set: SetState<GadgetState>, get: GetState<GadgetState>) => ({
  ...defaultState,
  setScreen: (screen: string) => {
    set({ screen })
  },
  reset: () => {
    set(defaultState)
  },
  fetchDefault: async (price: string) => {
    set({ loading: true })
    try {
      const { data: response } = await Axios.get(
        `products?policy_type=gadget&price=${parseFloat(price.replace(/,/g, ''))}`
      )
      set({ loading: false, policies: response.data.products })
    } catch (error: any) {
      set({ loading: false })
      throw Error
    }
  },
  onboardBuyPolicy: async () => {
    const { gadgetDetails } = get()
    const { bvn, email, BVNdetails } = useBVNStore.getState()
    set({ loading: true })
    try {
      const body = {
        user_data: {
          first_name: BVNdetails.first_name,
          last_name: BVNdetails.last_name,
          middle_name: BVNdetails.middle_name,
          dob: moment(BVNdetails.dob).format('YYYY-MM-DD'),
          email,
          bvn,
          phone_number: BVNdetails.phone_number,
          gender: BVNdetails.gender.charAt(0)
        },
        gadget_data: {
          brand: gadgetDetails.brand,
          model: gadgetDetails.model,
          price: parseFloat(gadgetDetails.price.replace(/,/g, ''))
        },
        product_id: String(gadgetDetails.policy.id)
      }

      const { data } = await Axios.post(`policy/gadget/onboard`, body)

      set({
        loading: false,
        user_id: data.data.user_id,
        policy_id: data.data.id,
        policy_number: data.data.policy_number
      })
      return true
    } catch (error: any) {
      if (error?.response?.data?.message.includes('to complete')) {
        set({ loading: false, errorMessage: error?.response?.data?.message })
        return
      }
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  setErrorMsg: () => {
    set({ errorMessage: '' })
  },
  buyPolicy: async () => {
    const { gadgetDetails } = get()
    set({ loading: true })
    try {
      const body = {
        gadget_data: {
          brand: gadgetDetails.brand,
          model: gadgetDetails.model,
          price: parseFloat(gadgetDetails.price.replace(/,/g, ''))
        },
        product_id: String(gadgetDetails.policy.id)
      }

      const { data } = await Axios.post(`policy/gadget`, body)

      set({
        loading: false,
        user_id: data.data.user_id,
        policy_id: data.data.id,
        policy_number: data.data.policy_number
      })
      return true
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  generateAccount: async (policy_id?: any, user_id?: any) => {
    if (!policy_id || !user_id) {
      policy_id = get().policy_id
      user_id = get().user_id
    }
    set({ loading: true })
    try {
      const { data } = await Axios.post(`vnuban`, { user_id, policy_id: String(policy_id) })
      set({ loading: false, paymentDetails: data.data })
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  confirmPayment: async (ref: string) => {
    set({ loading: true })
    try {
      const { data } = await Axios.get(`vnuban/verify-transaction?reference=${ref}`)
      set({ loading: false })
      return data.message
    } catch (error: any) {
      set({ loading: false })
      handleAxiosError(error)
    }
  },
  setLoading(loading: boolean) {
    set({ loading })
  },
  setGadgetDetails: async (values: any) => {
    const { policies } = get()
    // const period = policies.find((item) => item.id == values.period)
    set({ gadgetDetails: { ...values, policy: policies[0] }, screen: screens.GADGET_POLICY })
  }
})

const useGadgetStore = create<GadgetState>(GadgetStore)

export default useGadgetStore
